import React from "react";
import { CATEGORY_LABELS, ACTIONS } from "@cadenza/i18n-core";
import { useLanguageContext } from "@cadenza/i18n-react";
import { MenuRoot, MenuButton, MenuList, MenuItem } from "@cadenza/ui";
import { useRADSelector } from "./hooks";

const RADSelector = () => {
  const { rads, handleNavigation } = useRADSelector();
  const { STRINGS = {} } = useLanguageContext() || {};
  const RAD = STRINGS[CATEGORY_LABELS.RAD] || "Role Activity Diagram";
  const SELECT = STRINGS[ACTIONS.SELECT] || "Select";
  const TITLE = `${SELECT} ${RAD}`;

  if (!rads?.length) {
    return (
      <MenuRoot>
        {(api) => (
          <div style={{ position: "relative" }}>
            <MenuButton api={api} title={TITLE} aria-label={TITLE} disabled>
              {SELECT}
            </MenuButton>
          </div>
        )}
      </MenuRoot>
    );
  }

  return (
    <MenuRoot>
      {(api) => (
        <div style={{ position: "relative" }}>
          <MenuButton api={api} title={TITLE} aria-label={TITLE}>
            {SELECT}
          </MenuButton>

          <MenuList api={api}>
            {rads.map((rad) => (
              <MenuItem
                key={rad.id}
                onSelect={() => {
                  handleNavigation(rad.id);
                  api.close();
                }}
              >
                {rad.info?.name || rad.id}
              </MenuItem>
            ))}
          </MenuList>
        </div>
      )}
    </MenuRoot>
  );
};

export default RADSelector;
